import { FETCH_ATTACHMENTS_REQUEST } from './types'

export const buildConversationAttachmentsRequestKey = ticketId =>
  `${FETCH_ATTACHMENTS_REQUEST}_${ticketId}`
